import PageShell from '@/pages/shared/PageShell';

export default function CommercialLaw() {
  return (
    <PageShell
      title="特定商取引法に基づく表記｜”おもいむすび”"
      description="”おもいむすび”の特定商取引法に基づく表記。販売業者、運営責任者、所在地、連絡先などを記載しています。"
      canonical="https://omoimusubi.asia/commercial-law/"
      h1="特定商取引法に基づく表記"
      showCTA={false}
      relatedLinks={[
        { label: '利用規約', path: '/terms/' },
        { label: 'プライバシーポリシー', path: '/privacy/' },
      ]}
    >
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">販売業者</span>
          <span className="text-sm text-foreground-800">株式会社cafoot</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">運営責任者</span>
          <span className="text-sm text-foreground-800">菅原一成（代表取締役）</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">所在地</span>
          <span className="text-sm text-foreground-800">〒155-0034 東京都世田谷区代沢3-16-16 STEP101</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">電話番号</span>
          <span className="text-sm text-foreground-800">お問い合わせフォームよりご連絡ください（電話番号は、ご請求があれば遅滞なく開示いたします）</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">メールアドレス</span>
          <span className="text-sm text-foreground-800">お問い合わせフォームよりご連絡ください（メールアドレスは、ご請求があれば遅滞なく開示いたします）</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">販売価格</span>
          <span className="text-sm text-foreground-800">料金ページに記載のとおり</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">支払方法</span>
          <span className="text-sm text-foreground-800">銀行振込 / クレジットカード</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">サービスの提供時期</span>
          <span className="text-sm text-foreground-800">利用登録完了後、即時</span>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-background-200/70 py-3">
          <span className="text-sm font-medium text-foreground-700 sm:w-48 shrink-0">返品・解約について</span>
          <span className="text-sm text-foreground-800">利用規約に基づきます</span>
        </div>
      </div>
      <p className="text-sm text-foreground-500 mt-10">※ 本表記は仮のものです。正式なサービス提供時には適切な内容に更新されます。</p>
    </PageShell>
  );
}